var m = require('mithril');
var key = require('../../libs/keybindings');
var write = require('../models/write');

var modal = require('../../layout/components/modal');

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});

write.editDialogue = function (record, parentRid) {
  write.initForm(record, parentRid);

  var submit = function () {
    return write.save()
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title('Write Point: ' + record.name)
  modal.vm.body = write.view,
  modal.vm.buttons([
    {
      label: "Submit",
      class: "btn-good",
      func: submit
    }
  ]);

  modal.vm.open({
    suppressPointUpdates: [
      record && record.in && record.in['@rid'],
      record && record.in && record.in.writeAlternatePoint
    ]
  });
}

module.exports = write;
